<template>
  <div>
    <v-layout row wrap>
      <div>
        <div
          class="subheading grey--text text--darken-1 py-3"
        >{{ $t('screener.save.geo_blocking.description') }}</div>
      </div>
      <!-- Blocking Type -->
      <v-flex xs12>
        <v-radio-group
          hide-details
          v-model="geo_blocking_local.blocking_for"
          row
          @change="inputHandler"
          class="mt-0"
          color="primary"
        >
          <span
            class="subheading grey--text text--darken-1 pr-1"
          >{{ $t('screener.geo_blocking.blocking_for.label') }}</span>
          <RadioInput
            :value="DEFINES.GEO_BLOCKING.FOR.COUNTRIES"
            :label="$t('screener.save.geo_blocking.countries')"
            :tooltip="$t('screener.save.geo_blocking.countries.tooltip')"
          ></RadioInput>
          <RadioInput
            :value="DEFINES.GEO_BLOCKING.FOR.CITY"
            :label="$t('screener.save.geo_blocking.city')"
            :tooltip="$t('screener.save.geo_blocking.city.tooltip')"
          ></RadioInput>
        </v-radio-group>
      </v-flex>
      <!-- Blocking Type -->
      <v-flex xs12>
        <v-radio-group
          hide-details
          v-model="geo_blocking_local.blocking_type"
          row
          @change="inputHandler"
          class="mt-2"
        >
          <span
            class="subheading grey--text text--darken-1 pr-1"
          >{{ $t('screener.geo_blocking.blocking_type.label') }}</span>
          <RadioInput
            :value="DEFINES.GEO_BLOCKING.TYPE.BLACKLIST"
            :label="$t('screener.save.geo_blocking.blacklist')"
            :tooltip="$t('screener.save.geo_blocking.blacklist.tooltip')"
          ></RadioInput>
          <RadioInput
            :value="DEFINES.GEO_BLOCKING.TYPE.WHITELIST"
            :label="$t('screener.save.geo_blocking.whitelist')"
            :tooltip="$t('screener.save.geo_blocking.whitelist.tooltip')"
          ></RadioInput>
        </v-radio-group>
      </v-flex>
      <!-- In case of country level blocking -->
      <v-flex
        xs12
        v-if="
          geo_blocking_local.blocking_for == DEFINES.GEO_BLOCKING.FOR.COUNTRIES
        "
      >
        <v-autocomplete
          v-model="geo_blocking_local.country_code"
          :items="countries"
          :label="$t('screener.geo_blocking.countries.label')"
          item-text="name"
          item-value="iso_3166_2"
          multiple
          :rules="geo_blocking_local.blocking_type &&  geo_blocking_local.blocking_for ? [rules.min_length(1)] : []"
          @change="inputHandler"
          @input="searchInput = null"
          :search-input.sync="searchInput"
        ></v-autocomplete>
      </v-flex>
      <!-- In case of city level blocking -->
      <v-flex xs12 v-if="geo_blocking_local.blocking_for == DEFINES.GEO_BLOCKING.FOR.CITY">
        <VueGooglePlaces
          :api-key="DEFINES.GOOGLE_API_KEY"
          types="(cities)"
          :placeholder="$t('screener.save.geo_blocking.city_input.label')"
          @placechanged="setCityData"
          @noresult="setCityData"
        >
          <v-text-field
            :placeholder="$t('screener.save.geo_blocking.city_input.label')"
            id="id"
            :value="geo_blocking_local.city"
            :rules="geo_blocking_local.blocking_type &&  geo_blocking_local.blocking_for ? [rules.required] : []"
          ></v-text-field>
        </VueGooglePlaces>
        <div>
          <v-icon size="18" color="red" class="pr-1">mdi-information-outline</v-icon>
          <span class="body-2 greyDarken3--text">
            {{
            $t('screener.save.geo_blocking.important_notes')
            }}
          </span>
          <ul>
            <li
              class="body-1 greyDarken3--text my-1"
              v-for="note in notes"
              :key="note.index"
            >{{ note.text }}</li>
          </ul>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RadioInput from "@/components/RadioInput";
import { VuetifyGooglePlaces } from "vue-google-places";
import i18n from "@/i18n";
import rules from "@/validation";

export default {
  name: "GeoBlocking",
  model: {
    prop: "geo_blocking",
    event: "input"
  },
  props: {
    geo_blocking: {
      type: Object
    }
  },
  data() {
    return {
      rules,
      searchInput: null,
      geo_blocking_local: {
        blocking_for: null,
        city: null,
        blocking_type: null,
        country_code: []
      },
      notes: [
        { text: i18n.t("screener.save.geo_blocking.important_notes.note_1") },
        { text: i18n.t("screener.save.geo_blocking.important_notes.note_2") }
      ]
    };
  },
  components: {
    RadioInput,
    VuetifyGooglePlaces
  },
  computed: {
    ...mapState({
      countries: state => state.country.list
    })
  },
  created() {
    // this.getCountries();
  },
  watch: {
    geo_blocking: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.geo_blocking) {
        return;
      }
      this.geo_blocking_local = this.geo_blocking;
    },
    async getCountries() {
      try {
        return await this.$store.dispatch("country/list");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    inputHandler() {
      this.$emit("input", this.geo_blocking_local);
    },
    setCityData: function(cityData) {
      this.geo_blocking_local.city = cityData.name;
    }
  }
};
</script>
